let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0YeFX")).then(() => parcelRequire('4Sft0'));